<template>
  <main id="myPageApp" role="main">
        <div class="grid-container" v-if="showMenu">
            <div class="grid-x">
                <div class="head head--blue cell">
                    <div class="head__content">
                        <h1 class="head__title">{{labels.title}}</h1>
                        <div class="grid-container mega mega--links">
                            <div class="grid-x hide-for-print" v-if="role !== 'public'">
                                <router-link to="/MyStudiesResearcher" class="mega__link medium-4 cell" v-if="role === 'researcher'">{{labels.myStudies}}</router-link>
                                <router-link to="Overview" class="mega__link medium-4 cell" v-if="role === 'researcher'">{{labels.studyOverview}}</router-link>
                                <router-link to="/" class="mega__link medium-4 cell">{{labels.myLibrary}}</router-link>
                                <router-link to="/MyStudies" class="mega__link medium-4 cell" v-if="role === 'member'">{{labels.myStudies}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <router-view></router-view>
    <generic-error-message></generic-error-message>
  </main>
</template>

<script>
const routeNames = ['StudyOverview', 'MyStudiesResearcher', 'MyStudiesMember', 'MyLibrary'];
export default {
    name: 'myPageApp',
    data() {
        return {
            role: window.vm.role || 'public'
        }
    },
    computed: {
        showMenu() {
            return routeNames.indexOf(this.$route.name) !== -1;
        },
        labels() {
            return this.$store.state.labels['pages.mypage'] || { };
        },
        mystudiesRoute() {
            return (this.role === 'member') ? '/' : '/MyStudies';
        }
    },
    mounted() {
        this.$store.dispatch('getLabels', { label: 'pages.mypage' });
    }
}
</script>

<style lang="scss">
  @import './styles/global';
</style>



// WEBPACK FOOTER //
// src/app_MyPageApp.vue